import { Navigate, Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';
import { ApiPricingScreen } from '@/features/admin-pricing/pages/ApiPricingScreen';

import { DashboardScreen } from './pages/DashboardScreen';

export const dashboardRoutes = (
  <>
    <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <OnboardingCompletionGuard>
            <DashboardScreen />
          </OnboardingCompletionGuard>
        </ProtectedRoute>
      }
    />
    <Route
      path="/t/:tenantId/dashboard"
      element={
        <ProtectedRoute>
          <OnboardingCompletionGuard>
            <Navigate to="/dashboard" replace />
          </OnboardingCompletionGuard>
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin"
      element={
        <ProtectedRoute>
          <ApiPricingScreen />
        </ProtectedRoute>
      }
    />
  </>
);
